import { defineMessages } from 'react-intl'

const scope =
  'platform.banking.features.createExternalBankAccount.views.externalBankAccountForm'

export default defineMessages({
  securityNotice: {
    id: `${scope}.securityNotice`,
    defaultMessage:
      'For security, full vendor payment information details will not be accessible after creation.',
  },
  nameLabel: {
    id: `${scope}.nameLabel`,
    defaultMessage: 'Account name',
  },
  namePlaceholder: {
    id: `${scope}.namePlaceholder`,
    defaultMessage: 'Enter account name',
  },
  typeLabel: {
    id: `${scope}.typeLabel`,
    defaultMessage: 'Payment type',
  },
  typePlaceholder: {
    id: `${scope}.typePlaceholder`,
    defaultMessage: 'Type',
  },
  typeOther: {
    id: `${scope}.typeOther`,
    defaultMessage: 'Other',
  },
  typeCheck: {
    id: `${scope}.typeCheck`,
    defaultMessage: 'Check',
  },
  typeAch: {
    id: `${scope}.typeAch`,
    defaultMessage: 'ACH',
  },
  currencyLabel: {
    id: `${scope}.currencyLabel`,
    defaultMessage: 'Currency',
  },
  descriptionLabel: {
    id: `${scope}.descriptionLabel`,
    defaultMessage: 'Description',
  },
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'Description',
  },
  startNumberLabel: {
    id: `${scope}.startNumberLabel`,
    defaultMessage: 'Check numbers start at',
  },
  startNumberPlaceholder: {
    id: `${scope}.startNumberPlaceholder`,
    defaultMessage: 'Enter the first check number',
  },
  bankNameLabel: {
    id: `${scope}.bankNameLabel`,
    defaultMessage: 'Bank name',
  },
  bankNamePlaceholder: {
    id: `${scope}.bankNamePlaceholder`,
    defaultMessage: 'Enter bank name',
  },
  bankRoutingNumberLabel: {
    id: `${scope}.bankRoutingNumberLabel`,
    defaultMessage: 'Bank routing number',
  },
  bankRoutingNumberPlaceholder: {
    id: `${scope}.bankRoutingNumberPlaceholder`,
    defaultMessage: 'Enter bank routing number',
  },
  companyNameLabel: {
    id: `${scope}.companyNameLabel`,
    defaultMessage: 'Company name',
  },
  companyNamePlaceholder: {
    id: `${scope}.companyNamePlaceholder`,
    defaultMessage: 'Company name',
  },
  companyRoutingNumberLabel: {
    id: `${scope}.companyRoutingNumberLabel`,
    defaultMessage: 'Company account number',
  },
  companyRoutingNumberPlaceholder: {
    id: `${scope}.companyRoutingNumberPlaceholder`,
    defaultMessage: 'Enter company account number',
  },
  companyTaxIdLabel: {
    id: `${scope}.companyTaxIdLabel`,
    defaultMessage: 'Company tax ID',
  },
  companyTaxIdPlaceholder: {
    id: `${scope}.companyTaxIdPlaceholder`,
    defaultMessage: 'Enter company tax ID',
  },
  glCodeLabel: {
    id: `${scope}.glCodeLabel`,
    defaultMessage: 'GL code',
  },
  glCodePlaceholder: {
    id: `${scope}.glCodePlaceholder`,
    defaultMessage: 'Enter GL code',
  },
  createAnotherCheckbox: {
    id: `${scope}.createAnotherCheckbox`,
    defaultMessage: 'Create another after save',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  addAccountButton: {
    id: `${scope}.addAccountButton`,
    defaultMessage: 'Add account',
  },
  nameRequiredError: {
    id: `${scope}.nameRequiredError`,
    defaultMessage: 'Account name is required',
  },
  typeRequiredError: {
    id: `${scope}.typeRequiredError`,
    defaultMessage: 'Payment type is required',
  },
  currencyRequiredError: {
    id: `${scope}.currencyRequiredError`,
    defaultMessage: 'Currency is required',
  },
  descriptionRequiredError: {
    id: `${scope}.descriptionRequiredError`,
    defaultMessage: 'Description is required',
  },
  startNumberRequiredError: {
    id: `${scope}.startNumberRequiredError`,
    defaultMessage: 'Check number is required',
  },
  bankNameRequiredError: {
    id: `${scope}.bankNameRequiredError`,
    defaultMessage: 'Bank name is required',
  },
  bankRoutingNumberRequiredError: {
    id: `${scope}.bankRoutingNumberRequiredError`,
    defaultMessage: 'Bank routing number is required',
  },
  companyNameRequiredError: {
    id: `${scope}.companyNameRequiredError`,
    defaultMessage: 'Company name is required',
  },
  companyRoutingNumberRequiredError: {
    id: `${scope}.companyRoutingNumberRequiredError`,
    defaultMessage: 'Company account number is required',
  },
  companyTaxIdRequiredError: {
    id: `${scope}.companyTaxIdRequiredError`,
    defaultMessage: 'Company tax ID is required',
  },
})
